import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Contribution History")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, " To view detailed contributions for each Production/Employer,click on the plus sign to the left of Production Name. If you wish to change the filters settings, click 'Change My Current Filters' button to return to the filter page. ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_HistoryResults = _resolveComponent("HistoryResults")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Alerts, { errors: $setup.errors }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_HistoryResults, {
              loading: $setup.loading,
              loadingTotals: $setup.loadingTotals,
              pageChanged: $setup.pageChanged,
              changePage: $setup.changePage,
              onResetFilters: $setup.resetFilters,
              onFetchPaginationData: $setup.fetchPaginationData
            }, null, 8, ["loading", "loadingTotals", "pageChanged", "changePage", "onResetFilters", "onFetchPaginationData"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}